import { DeviceAssignmentHistory as sdkHistory } from '@era/locations-sdk';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

export function selectIdFromHistory(history: DeviceAssignmentHistory) {
  return history.deviceId;
}

export const adapter: EntityAdapter<DeviceAssignmentHistory> = createEntityAdapter<DeviceAssignmentHistory>({
  selectId: selectIdFromHistory,
});

export interface DeviceAssignmentHistory {
  deviceId: string;
  history: sdkHistory[];
}

export type DeviceAssignmentHistoryState = EntityState<DeviceAssignmentHistory>;

export const initialState: DeviceAssignmentHistoryState = adapter.getInitialState();
